// Deleting a route can empty a day out from the middle or the start of a
// plan (e.g. delete Day 1's only route and the walk is now just "Day 2").
// These close the gap so the days left run 1, 2, 3… again — otherwise maxDay
// still counts the missing day and the plan keeps acting multi-day. Pure.

// Old day number → new day number, for every day that still has a route.
// Routes without a day (a lone first route) don't count.
export function closeDayGaps(routeDays: Array<number | undefined | null>): Record<number, number> {
  const days = [...new Set(routeDays.filter((d): d is number => typeof d === 'number'))].sort((a, b) => a - b);
  const map: Record<number, number> = {};
  days.forEach((day, i) => { map[day] = i + 1; });
  return map;
}

// Whether the map actually moves any day.
export function renumbersAnyDay(map: Record<number, number>): boolean {
  return Object.entries(map).some(([from, to]) => Number(from) !== to);
}

// Re-key something stored per day (day names, stage destinations) by the new
// numbers, dropping days that no longer exist.
export function remapByDay<T>(byDay: Record<number, T> | null | undefined, map: Record<number, number>): Record<number, T> {
  const out: Record<number, T> = {};
  Object.entries(byDay || {}).forEach(([day, value]) => {
    const to = map[Number(day)];
    if (to !== undefined) out[to] = value;
  });
  return out;
}
